<template>
    <ajax-table :data="data"
                :headers="headers"
                v-model:loading="ajaxTable.loading"
                v-model:search="ajaxTable.search"
                v-model:sort-by="ajaxTable.sortBy"
                v-model:sort-desc="ajaxTable.sortDesc"
                v-model:page="ajaxTable.page"
                v-model:items-per-page="ajaxTable.itemsPerPage"
                v-model:page-info="ajaxTable.pageInfo"
                :exportable="false"
                @loadData="getData"
                no-data-message="No addresses found"
    >

        <template #above_table_center>
            <div v-if="permissions.can('manage_addresses')" class="self-start flex items-start w-full md:w-auto ml:0 md:ml-2 gap-4 mb-4 sm:mb-0">

                <button-green-primary @click="createAddress" aria-label="Create New Address">
                    <div class="inline-flex">
                        <span class="lnr !text-base !font-bold icon-plus-circle mr-2"></span>
                        <span class="hidden sm:block">Create New Address</span>
                    </div>
                </button-green-primary>

                <download-excel
                    :fetch="exportData"
                    :fields="csvFields"
                    type="csv"
                    class="w-full"
                >
                    <button-blue-primary aria-label="Export Addresses">
                        <div class="inline-flex">
                            <span class="lnr !text-base !font-bold icon-share mr-2"></span>
                            <span class="hidden sm:block">Export Addresses</span>
                        </div>
                    </button-blue-primary>
                </download-excel>

            </div>
        </template>

        <!-- Column 1: Nickname -->
        <template #col-1="props">
            <div class="flex flex-col items-start justify-center">
                <span class="my-1 text-gray-700">
                    <div class="font-medium text-gray-900">{{ props.row.nickname }}</div>
                </span>
            </div>
        </template>

        <!-- Column 2: Name -->
        <template #col-2="props">
            <div class="flex flex-col items-start justify-center">
                <span class="my-1 text-gray-700">
                    <div class="font-medium text-gray-900">
                        {{ props.row.name }}
                        <span v-if="props.row.attention"><br>Attn: {{ props.row.attention }}</span>
                    </div>
                </span>
            </div>
        </template>

        <!-- Column 3: Street Address -->
        <template #col-3="props">
            <div class="flex flex-col items-start justify-center">
                <span class="my-1 text-gray-700">
                    <div class="font-medium text-gray-900">
                        {{ props.row.line1 }}<br>
                        <span v-if="props.row.line2">{{ props.row.line2 }}<br></span>
                        <span v-if="props.row.line3">{{ props.row.line3 }}<br></span>
                        {{ props.row.city_state_zip }}
                    </div>
                </span>
            </div>
        </template>


        <!-- Column 4: Street Address -->
        <template #col-4="props">
            <div class="flex flex-col items-start justify-center">
                <span class="my-1 text-gray-700 flex flex-wrap">
                    <div v-for="zone in props.row.zones">
                        <span class="inline-flex items-center m-1 px-2.5 py-0.5 rounded-md text-md font-medium bg-blue-100 text-blue-800">
                            {{ zone.name }}
                        </span>
                    </div>

                    <!-- No Zones -->
                    <div v-if="props.row.zones.length === 0">
                        <span class="inline-flex items-center m-1 px-2.5 py-0.5 rounded-md text-md font-medium bg-gray-100 text-gray-800">
                            No Zones
                        </span>
                    </div>
                </span>
            </div>
        </template>

        <!-- Column 5: Edit -->
        <template #col-5="props">
            <div class="flex flex-col items-start justify-center">
                <span class="my-1">
                    <a :href="this.company.buildCompanyRoute('addresses/' + props.row.id )" class="lnr !font-bold icon-pencil px-2 active:no-underline focus:no-underline hover:no-underline cursor-pointer" aria-label="Edit Address"></a>
                </span>
            </div>
        </template>

    </ajax-table>
</template>

<script>
import axios from 'axios'
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import AjaxTable from "@/components/elements/AjaxTable.vue";
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import _ from 'lodash';
import ButtonBluePrimary from "@/components/elements/buttons/ButtonBluePrimary.vue";
import ButtonGreenPrimary from "@/components/elements/buttons/ButtonGreenPrimary.vue";
import JsonExcel from "@/components/JsonExcel.vue";

export default {
    name: "AddressIndex",
    components: {ButtonGreenPrimary, ButtonBluePrimary ,'download-excel': JsonExcel, AjaxTable},
    mixins: [SonicuCoreMixin, ajaxTableMixin],
    data() {
        return {
            data: [],
            headers: [
                {
                    name: 'Nickname',
                    key: 'nickname',
                    show: 'sm'
                },
                {
                    name: 'Name',
                    key: 'name',
                    'show': 'md'
                },
                {
                    name: 'Address',
                    key: 'line1',
                    show: 'md'
                },
                {
                    name: 'Zones',
                    key: 'zones',
                    show: 'sm'
                },
                {
                    name: '',
                    key: 'id'
                }
            ],
            requestNumber: 0,
            processing: false,

            csvFields: {
                'Nickname': 'nickname',
                'Name': 'name',
                'Attention': 'attention',
                'Attention Email': 'attention_email',
                'Line 1': 'line1',
                'Line 2': 'line2',
                'Line 3': 'line3',
                'City': 'city',
                'State': 'state',
                'Zip': 'zip',
                'Zones': 'zones',
            },

            pageInfo: {
                total: 0
            },
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            this.ajaxTable.loading = true;
            this.requestNumber++;
            let params = JSON.parse(JSON.stringify(this.ajaxTable));
            params.requestNumber = this.requestNumber;
            axios.get(this.company.buildCompanyApiInternalRoute('addresses'),
                {
                    params: params
                })
                .then(response => {
                    let data = response.data;

                    this.ajaxUpdateTableData(data);
                    this.data = !_.isNil(data.data) ? data.data : [];

                  this.pageInfo.total = data?.meta?.total || 0;

                })
                .catch(error => {
                    console.log(error)
                })
                .then(() => {
                    this.ajaxTable.loading = false;
                });
        },
        createAddress() {
            window.location.href = this.company.buildCompanyRoute(`addresses/create`)
        },
        async exportData() {
            let params = JSON.parse(JSON.stringify(this.ajaxTable));
            return axios.get(this.company.buildCompanyApiInternalRoute('addresses'),
                {
                    params: {
                        itemsPerPage: this.pageInfo.total,
                        search: params.search,
                    }
                })
                .then(response => {
                    let data = response.data;

                    data.data.forEach((row) => {
                        row.zones = row.zones.map(zone => zone.name).join(', ');
                        return row;
                    });

                    return data.data;
                })
                .catch(error => {
                    console.log(error)
                });
        }
    }
}
</script>